import React from 'react';
import {Button, Link} from "@nextui-org/react";
import {useNavigate} from "react-router-dom";
import Footer from "../Components/Footer";

function HomePage(props) {
    const navigate = useNavigate();

    return (
        <section className={'relative'} style={{
            height: "85vh",
            width: "100vw",
        }}>
            <header className={'absolute'}
                    style={{top: 0, left: 0, right: 0, bottom: 0, height: "85vh", width: "100vw"}}>
                <div style={{
                    zIndex: 11,
                    top: 0,
                    height: "85vh",
                    width: "100vw",
                    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 1))"
                }} className={'text-center absolute px-3'}>
                    <p style={{marginTop: '30vh'}}
                       className={"text-xl sm:text-2xl md:text-3xl xl:text-4xl lg:text-5xl  font-bold"}>

                        {
                            "Discover Your Unique Minecraft Identity"
                        }
                    </p> <h1
                    className={'text-sm sm:text-xl md:text-2xl xl:text-3xl lg:text-4xl  font-normal text-center text-green'}>

                    {
                        "with the Ultimate Skin Hub"
                    }
                </h1>
                    <div className={'flex justify-center mt-10'}>
                        <Button color="warning" variant="shadow" className={'text-white font-light'} radius={'sm'}
                                onClick={
                                    () => {
                                        navigate("/skins");
                                    }
                                }>
                            Explore Skins Now
                        </Button>
                    </div>
                </div>
                <img className={'absolute'}
                     style={{top: 0, left: 0, right: 0, bottom: 0, height: "85vh", width: "100vw", objectFit: 'cover'}}
                     src={require('../assets/herobr.jpg')} alt={''}/>
            </header>
            <Footer className={'absolute'}
                    style={{bottom: 0, top: "105%", left: 0, width: "100%"}}/>
        </section>
    );
}

export default HomePage;